import React, { useState, useEffect, useRef, useContext } from 'react';
import "../../css/CRUDModal.css"
import DeleteConfirmationModal from "./DeleteConfirmationRetailer";
import { BankNameContext } from '../../context/BankNameContext';
import axios from "axios";
import CustomAlert from '../../helpers/CustomAlert';
import { toast } from 'react-toastify';
import { apiList, baseUrl } from '../../helpers/apiList';
import { axiosPostApi } from '../../helpers/interceptorServices';

const RetailerModal = ({ show, handleClose, editData, action, fetchRetailerData }) => {
  const { bankNames, loading, error } = useContext(BankNameContext);
  const loggedInUserName = sessionStorage.getItem('username');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [mccCodes, setMccCodes] = useState([]);
  const [formData, setFormData] = useState({
    username: loggedInUserName,
    name: '',
    address1: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    pinCode: '',
    firstContactPersonName: '',
    firstContactPersonMobileNo: '',
    secondContactPersonName: '',
    secondContactPersonMobileNo: '',
    bankName: '',
    accountNo: '',
    ifscCode: '',
    accountHolderName: '',
    mccDesc: "",
    mccCode: "",
    emailId: ""
  });
  const [errors, setErrors] = useState({
    name: '',
    address1: '',
    address2: '',
    pinCode: '',
    firstContactPersonName: '',
    firstContactPersonMobileNo: '',
    bankName: '',
    accountNo: '',
    ifscCode: '',
    accountHolderName: '',
    mccCode: "",
    emailId: ""
  });

  useEffect(() => {
    fetchMccCodes();
    if (action === 'add') {
      setFormData({
        username: loggedInUserName,
        name: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        state: '',
        pinCode: '',
        firstContactPersonName: '',
        firstContactPersonMobileNo: '',
        secondContactPersonName: '',
        secondContactPersonMobileNo: '',
        bankName: '',
        accountNo: '',
        ifscCode: '',
        accountHolderName: '',
        mccDesc: "",
        mccCode: "",
        emailId: ""
      });
    } else if (action === 'modify' || action === 'view' || action === 'delete') {
      setFormData({
        ...editData,
        username: loggedInUserName,
        state: editData?.state || '',
        city: editData?.city || '',
      });
    }
  }, [action, editData]);

  const fetchMccCodes = () => {
    axios
      .get(`${baseUrl}/sms/mcc`)
      .then(function (response) {
        setMccCodes(response?.data?.data);
      })
      .catch(function (error) {
        console.error('Error fetching MCC codes:', error);
      });
  };

  const handleMccChange = (event) => {
    const selectedMcc = event.target.value;
    const selectedMccDetails = mccCodes.find((mcc) => mcc.mcc === selectedMcc);

    let mccDesc = selectedMccDetails ? selectedMccDetails.description : '';
    setFormData((prevState) => ({
      ...prevState,
      mccCode: selectedMcc,
      mccDesc: mccDesc
    }));
  };

  const isViewMode = action === 'view';
  const isDeleteMode = action === 'delete';
  const isEditMode = action === 'modify';

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;
    if (id === 'name' || id === 'ifscCode') {
      updatedValue = value.toUpperCase();
    } else if (id === 'emailId') {
      updatedValue = value.toLowerCase();
    } else if (id === 'firstContactPersonMobileNo' || id === 'secondContactPersonMobileNo' || id === 'accountNo') {
      updatedValue = value.replace(/[^0-9]/g, ''); 
    }

    setFormData({ ...formData, [id]: updatedValue });

    if (id === 'pinCode') {
      validatePinCode(value);
    }
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = 'PinCode is required';
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = 'PinCode must be 6 digits';
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || 'Enter a valid Pincode';
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setFormData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          console.error('Error fetching pincode data:', error);
          newErrors.pinCode = 'Error fetching pincode data';
          setErrors(newErrors);
        });
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};
    // Name validation (between 2 and 50 characters)
    formData.name = formData.name.trim();
    if (!formData.name) {
      newErrors.name = 'Name is required';
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.name) || formData.name.length < 2 || formData.name.length > 50) {
      newErrors.name = 'Retailer name must be valid and between 2 and 50 characters';
    }

    // Address validation
    if (!formData.address1) {
      newErrors.address1 = 'Address is required';
    } else if (formData.address1.length < 5 || formData.address1.length > 50) {
      newErrors.address1 = 'Address1 must be between 5 and 50 characters';
    }

    if (!formData.address2) {
      newErrors.address2 = 'Address is required';
    } else if (formData.address2.length < 5 || formData.address2.length > 50) {
      newErrors.address2 = 'Address2 must be between 5 and 50 characters';
    }

    if (!formData.pinCode) {
      newErrors.pinCode = 'Pincode is required';
    } else if (!/^\d{6}$/.test(formData.pinCode)) {
      newErrors.pinCode = 'Pincode must be 6 digits';
    }

    // Email validation (required and valid email)
    if (!formData.emailId) {
      newErrors.emailId = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.emailId)) {
      newErrors.emailId = 'Email is invalid';
    }

    // First contact person name validation (between 2 and 50 characters)
    if (!formData.firstContactPersonName) {
      newErrors.firstContactPersonName = 'First contact person name is required';
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.firstContactPersonName) || formData.firstContactPersonName.length < 2 || formData.firstContactPersonName.length > 50) {
      newErrors.firstContactPersonName = 'First contact person name must be between 2 and 50 characters';
    }

    // First contact person mobile number validation
    if (!formData.firstContactPersonMobileNo) {
      newErrors.firstContactPersonMobileNo = 'First contact person mobile number is required';
    } else if (!/^\d{10}$/.test(formData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo = 'Mobile number must be exactly 10 digits';
    }

     // Second contact person name validation (between 2 and 50 characters)
     if (formData.secondContactPersonName && (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.secondContactPersonName) || formData.secondContactPersonName.length < 2 || formData.secondContactPersonName.length > 50)) {
      newErrors.secondContactPersonName = 'Second contact person name must be between 2 and 50 characters';
    }

     // Second contact person mobile number validation
     if (formData.secondContactPersonMobileNo && !/^\d{10}$/.test(formData.secondContactPersonMobileNo)) {
      newErrors.secondContactPersonMobileNo = 'Mobile number must be exactly 10 digits';
    }

    // Bank Name validation
    if (!formData.bankName) {
      newErrors.bankName = 'Bank Name is required';
    }

    if (!formData.mccDesc) {
      newErrors.mccDesc = 'MCC Description is required';
    }

    if (!formData.mccCode) {
      newErrors.mccCode = 'MCC Code is required';
    }

    // IFSC Code validation (must be 11 characters)
    if (!formData.ifscCode) {
      newErrors.ifscCode = 'IFSC code is required';
    } else if (!/^[A-Z]{4}[0-9]{7}$/.test(formData.ifscCode)) {
      newErrors.ifscCode = 'IFSC Code must be 4 alphabets followed by 7 digits';
    }

    // Account Number validation (between digits 5 to 30)
    if (!formData.accountNo) {
      newErrors.accountNo = 'Account Number is required';
    } else if (!/^\d{5,30}$/.test(formData.accountNo)) {
      newErrors.accountNo = 'Account Number must be between 5 and 30 digits';
    }

    // Account Name validation (between 2 and 50 characters)
    formData.accountHolderName = formData.accountHolderName.trim();
    if (!formData.accountHolderName) {
      newErrors.accountHolderName = 'Account Name is required';
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.accountHolderName) || formData.accountHolderName.length < 2 || formData.accountHolderName.length > 50) {
      newErrors.accountHolderName = 'Account name must be valid and between 2 and 50 characters';
    }

    return newErrors;
  }

  const handleAddRetailer = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);
      let apiUrl = '';
      let successMessage = '';

      if (action === 'add') {
        apiUrl = apiList.CREATE_RETAILER_DATA; // Add 
        successMessage = 'Retailer added successfully';
      } else if (action === 'modify') {
        apiUrl = apiList.MODIFY_RETAILER_DATA; // Modify
        successMessage = 'Retailer details modified successfully';
      }

      axiosPostApi(apiUrl, formData)
        .then((response) => {
          if (response.status === 200 && response.data.status === true) {
            toast.success(successMessage, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            handleClose(); // Close the modal
            fetchRetailerData(1);
          } else {
            CustomAlert({
              title: action === 'add' ? "Failed to Add Retailer" : "Failed to Modify Retailer",
              text: response.data.message || 'There was an issue processing the request. Please try again.',
              icon: 'error',
              confirmButtonText: 'Retry',
            });
          }
        })
        .catch((error) => {
          console.error('Error processing request:', error);
          CustomAlert({
            title: "Error",
            text: action === 'add' ? "An error occurred while adding the retailer. Please try again later." : "An error occurred while modifying the retailer. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  }

  const handleBack = () => {
    handleClose();
    setErrors({});
  }

  return (
    <>
      <div
        className={`modal fade ${show ? 'show' : ''}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">{action.charAt(0).toUpperCase() + action.slice(1)} Retailer Details</h5>
            </div>
            <form onSubmit={(e) => handleAddRetailer(e)}>
              <div className="scoped-modal modal-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">Retailer Name<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Retailer Name"
                        id="name"
                        value={formData?.name || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.name ? (<span className="error">{errors.name}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="emailId">Retailer Email Id<span style={{color: "red"}}>*</span></label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email Id"
                        id="emailId"
                        value={formData.emailId} onChange={handleInputChange} disabled={isViewMode || isDeleteMode}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.emailId ? (<span className="error">{errors.emailId}</span>) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address1">Address 1<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 1"
                        id="address1"
                        value={formData?.address1 || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.address1 ? (<span className="error">{errors.address1}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address2">Address 2<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 2"
                        id="address2"
                        value={formData?.address2 || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.address2 ? (<span className="error">{errors.address2}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address3">Address 3</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 3"
                        id="address3"
                        value={formData?.address3 || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="pinCode">Pin Code<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Pin Code"
                        id="pinCode"
                        value={formData.pinCode} disabled={isViewMode || isDeleteMode} onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.pinCode ? (<span className="error">{errors.pinCode}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="state">State</label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        value={formData.state || 'State'}
                        style={{ cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="city">City</label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        value={formData.city || 'City'}
                        style={{ cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstContactPersonName">Contact Person Name 1<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person Name 1"
                        id="firstContactPersonName"
                        value={formData?.firstContactPersonName || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.firstContactPersonName ? (<span className="error">{errors.firstContactPersonName}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstContactPersonMobileNo">Contact Person 1 Mobile No.<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person 1 Mobile No."
                        id="firstContactPersonMobileNo"
                        value={formData?.firstContactPersonMobileNo || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.firstContactPersonMobileNo ? (<span className="error">{errors.firstContactPersonMobileNo}</span>) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="secondContactPersonName">Contact Person Name 2</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person Name 2"
                        id="secondContactPersonName"
                        value={formData?.secondContactPersonName || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                       {!(isViewMode || isDeleteMode || isEditMode) && errors.secondContactPersonName ? (<span className="error">{errors.secondContactPersonName}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="secondContactPersonMobileNo">Contact Person 2 Mobile No.</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person 2 Mobile No."
                        id="secondContactPersonMobileNo"
                        value={formData?.secondContactPersonMobileNo || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.secondContactPersonMobileNo ? (<span className="error">{errors.secondContactPersonMobileNo}</span>) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="bankName">Settlement Bank Name<span style={{color: "red"}}>*</span></label>
                      <select
                        id="bankName"
                        className="form-select"
                        value={formData?.bankName || ''}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange} style={{ appearance: "listbox" }}
                      >
                        <option value="">Select Bank</option>
                        {bankNames?.map((bank) => (
                          <option key={bank.bankId} value={bank.bankName}>
                            {bank.bankName}
                          </option>
                        ))}
                      </select>
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.bankName ? (<span className="error">{errors.bankName}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="accountNo">Settlement Account No<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Settlement Account No"
                        id="accountNo"
                        value={formData?.accountNo || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.accountNo ? (<span className="error">{errors.accountNo}</span>) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="ifscCode">Settlement IFSC Code<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Settlement IFSC Code"
                        id="ifscCode"
                        value={formData?.ifscCode || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.ifscCode ? (<span className="error">{errors.ifscCode}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="accountHolderName">Settlement Account Name<span style={{color: "red"}}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Settlement Account Name"
                        id="accountHolderName"
                        value={formData?.accountHolderName || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode || isEditMode) && errors.accountHolderName ? (<span className="error">{errors.accountHolderName}</span>) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mccCode">MCC Code<span style={{color: "red"}}>*</span></label>
                      <select id="mccCode" className="form-control" style={{ appearance: "listbox" }} value={formData?.mccCode || ''} disabled={isViewMode || isDeleteMode} onChange={handleMccChange}>
                        <option value="">Select MCC Code</option>
                        {Array.isArray(mccCodes) && mccCodes.length > 0 ? (
                          mccCodes.map((mcc) => (
                            <option key={mcc.mcc} value={mcc.mcc}>
                              {mcc.mcc}
                            </option>
                          ))
                        ) : (
                          <option disabled>No MCC Codes Available</option>
                        )}
                      </select>


                      {!(isViewMode || isDeleteMode || isEditMode) && errors.mccCode ? (<span className="error">{errors.mccCode}</span>) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mccDesc">MCC Description</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="MCC Description"
                        id="mccDesc"
                        value={formData?.mccDesc || ''} disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                        style={{ cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="scoped-modal modal-footer">
                <button type="button" className="btn btn-back" onClick={handleBack}>
                  Back
                </button>
                {!isViewMode && !isDeleteMode && <button type="submit" className="btn btn-submit">
                  {isEditMode ? "Update" : "Submit"}
                </button>}
                {isDeleteMode && <button type="button" className="btn btn-danger" onClick={openModal}>Delete</button>}
                <DeleteConfirmationModal
                  isOpen={isModalOpen}
                  onClose={closeModal}
                  handleClose={handleClose}
                  editData={editData}
                  fetchRetailerData={fetchRetailerData}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default RetailerModal;
